import React from "react";
import { createPortal } from "react-dom";

import "../modal/modalDeleteConfimation.css";

const ModalDeleteConfirmation = ({
  isShowModal,
  onCloseModal,
  onDeleteConfirmed,
  idToDelete,
}) => {
  return createPortal(
    isShowModal && (
      <div className="modal-delete-confirmation-container">
        <div className="modal-delete-confirmation-content">
          <header className="modal-delete-confirmation-header">
            <h2 className="modal-delete-confirmation-header-title">
              Konfirmasi Menghapus Item
            </h2>
            <button
              className="modal-delete-confirmation-close-header-button"
              onClick={onCloseModal}
            >
              &times;
            </button>
          </header>
          <main className="modal-delete-confirmation-main">
            Apakah anda ingin menghapus item tersebut?
          </main>
          <footer className="modal-delete-confirmation-footer">
            <button
              className="modal-delete-confirmation-button"
              onClick={() => {
                onDeleteConfirmed(idToDelete);
              }}
            >
              Hapus
            </button>
            <button
              className="modal-delete-confirmation-close-button"
              onClick={onCloseModal}
            >
              Batal
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalDeleteConfirmation;
